// extracted by mini-css-extract-plugin
module.exports = {"taskList":"styles_taskList__1TEOL","content":"styles_content__ZJLhx"};